import React from "react";
import RangeSlider from "rc-slider/lib/Range";
import { PriceInput } from "./styled";
import Fieldset from "_c/form/Fieldset";
import Label from "_c/form/Label";
import TextInput from "_c/form/TextInput";
import { SEARCH_NS as ns } from "@/i18n/ns";

const MAX = 100000;
const PriceSlider = ({ value, onChange, onBlur, t }) => {
  const startLabel = t(`${ns}:filters.start_price`);
  const endLabel = t(`${ns}:filters.end_price`);
  return (
    <Fieldset style={{ marginTop: "25px" }}>
      <Label as="legend">{t(`${ns}:filters.price`)}</Label>
      <div>
        <PriceInput>
          <TextInput
            onChange={({ target }) => onChange([+target.value, value[1]])}
            title={startLabel}
            onBlur={onBlur}
            value={value[0]}
            min={0}
            max={MAX}
            type="number"
            step={1}
          />
          <span
            css={`
              color: var(--font-color-accent);
            `}
          >
            -
          </span>
          <TextInput
            onChange={({ target }) => onChange([value[0], +target.value])}
            title={endLabel}
            onBlur={onBlur}
            value={value[1]}
            min={0}
            max={MAX}
            type="number"
            step={1}
          />
        </PriceInput>
      </div>
      <RangeSlider
        ariaLabelGroupForHandles={[startLabel, endLabel]}
        onBlur={onBlur}
        step={100}
        min={0}
        allowCross={true}
        value={value}
        onChange={onChange}
        max={MAX}
      />
    </Fieldset>
  );
};
export default PriceSlider;
